import * as api from "@/api/cds/rbi";
import { addAttachment } from "@/api/welds";
import { Datasheet } from "@/api/datasheets";
import { InspectorContext } from "./reducer";
import { InspectorRow } from "@/api/cds/rbi";
import { Page } from "@/util";
import { useContext } from "react";
import { useMutation, useQuery } from "react-query";
import { WeldListFilters } from "./types";

export function useGetWeldList(filters: WeldListFilters, datasheet?: Datasheet) {
  const datasheetId = datasheet?.datasheetId ?? "";
  return useQuery({
    enabled: Boolean(datasheet),
    queryKey: ["rbi/inspector/welds", { datasheetId, filters }],
    queryFn: () => api.getInspectorWelds(datasheetId, filters),
  });
}

export function useGetInspections(weldIds: string[]) {
  const { updateState } = useContext(InspectorContext);

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["rbi/inspector/inspections", weldIds],
    queryFn: () => api.getInspectorRows(weldIds),
    onSuccess: (data) => {
      updateState({ type: "Inspections", payload: data });
    },
  });
}

export function useSave() {
  return useMutation(async (inspections: InspectorRow[]) => {
    await api.saveInspectorRows(inspections);
    await saveAttachments(inspections);
    Page.redirect("rbi/cds/inspector");
  });
}

function saveAttachments(inspections: InspectorRow[]) {
  return Promise.all(
    inspections.map(async (row) => {
      if (row.attachment) {
        await addAttachment(row.weldId, row.attachment);
      }
    })
  );
}
